"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var IconContents = tslib_1.__importStar(require("./generated/iconContents"));
exports.IconContents = IconContents;
var IconNames = tslib_1.__importStar(require("./generated/iconNames"));
exports.IconNames = IconNames;
var iconSvgPaths_1 = require("./generated/iconSvgPaths");
exports.IconSvgPaths16 = iconSvgPaths_1.IconSvgPaths16;
exports.IconSvgPaths20 = iconSvgPaths_1.IconSvgPaths20;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/icons/lib/cjs/index.js
// module id = 130
// module chunks = 0